module.exports = __webpack_public_path__ + "img/conny-f-stage2-hungry.aa33d5ee.png";